import { AgGridReact } from "ag-grid-react";
import { message, notification, Spin } from "antd";
import { useEffect, useState } from "react";
import {
  dateFilterParams,
  dateFormatter,
  frameworkComponents,
  gridOption,
} from "../constants/ag-grid.constants";
import { APIs } from "../constants/api.constants";
import CreateTag from "../custom-components/tagging-manager-popups/create-tag";
import { ApiService } from "../services/ApiService";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "../public/styles/style.css";
import EditTag from "../custom-components/tagging-manager-popups/edit-tag";

export default function TaggingManager() {
  const [loading, setLoading] = useState(false);
  const [loadingRows, setLoadingRows] = useState(false);
  const [taggingData, setTaggingData] = useState([]);
  const [visibility, setVisibility] = useState(false);
  const [name, setName] = useState("");
  const [tagType, setTagType] = useState(null);
  const [editVisibility, setEditVisibility] = useState(false);
  const [tagId, setTagId] = useState(null);

  const columnDefs = [
    {
      headerName: "ID",
      field: "id",
      minWidth: 80,
      sort: "desc",
      editable: false,
    },
    {
      headerName: "Tag Type",
      field: "tag_type",
      editable: false,
      minWidth: 80,
    },
    {
      headerName: "Tag Name",
      field: "tagging_name",
      editable: false,
      minWidth: 350,
    },
    {
      headerName: "Number of Used",
      field: "count",
      editable: false,
      minWidth: 80,
    },
    {
      field: "Edit",
      editable: false,
      minWidth: 100,
      cellRenderer: "btnCellRenderer",
      cellRendererParams: {
        buttonText: "Edit",
        buttonClass: "primary",
        clicked: function (field) {
          resetInputs();
          setName(field.tagging_name);
          setTagId(field.id);
          setTagType(field.tag_type);
          toggleEditVisibility();
        },
      },
    },
    {
      headerName: "Created Date",
      field: "create_date",
      valueGetter: dateFormatter,
      minWidth: 200,
      editable: false,
      filter: "agDateColumnFilter",
      filterParams: dateFilterParams,
    },
    {
      field: "Deleted",
      editable: false,
      cellRenderer: "btnCellRenderer",
      cellRendererParams: {
        buttonText: "Delete",
        buttonClass: "primary",
        clicked: function (field) {
          deleteTag(field.id);
        },
      },
    },
  ];

  useEffect(() => {
    getTaggingData();
  }, []);

  async function getTaggingData() {
    setLoadingRows(true);
    ApiService.getRequest(APIs.tagging + "/all-tagging-count").then(
      (res) => {
        setLoadingRows(false);
        setTaggingData(res.data);
      },
      (error) => {
        setLoadingRows(false);
        notification["error"]({ message: "Having Problem Getting Data" });
      }
    );
  }

  function createNewTag() {
    if (name === "" || !tagType) {
      notification["error"]({ message: "Please Input All Value" });
      return;
    }
    setLoading(true);
    const postData = {
      tagging_name: name,
      tag_type: tagType,
    };
    ApiService.postRequest(APIs.tagging, postData).then(
      () => {
        message.success("Adding New Tag Successfully");
        resetInputs();
        setVisibility(false);
        getTaggingData();
        setLoading(false);
      },
      (error) => {
        notification["error"]({ message: error.message });
        setVisibility(false);
        setLoading(false);
      }
    );
  }

  function editTagging() {
    setLoading(true);
    const newData = {
      tagging_name: name,
      tag_type: tagType,
    };
    ApiService.updateRequest(APIs.tagging + "/" + tagId, newData).then(
      (res) => {
        resetInputs();
        setEditVisibility(false);
        getTaggingData();
        setLoading(false);
      },
      (error) => {
        notification["error"]({ message: error.message });
        setEditVisibility(false);
        setLoading(false);
      }
    );
  }

  function deleteTag(id) {
    setLoadingRows(true);
    ApiService.deleteRequest(APIs.tagging + "/" + id).then(() => {
      getTaggingData();
      setLoadingRows(false);
    });
  }

  function toggleVisibility() {
    visibility && resetInputs();
    setVisibility(!visibility);
  }

  function toggleEditVisibility() {
    editVisibility && resetInputs();
    setEditVisibility(!editVisibility);
  }

  function resetInputs() {
    setName("");
    setTagType(null);
    setTagId(null);
  }

  const createTagProps = {
    visibility,
    toggleVisibility,
    loading,
    name,
    setName,
    tagType,
    setTagType,
    createNewTag,
  };

  const editTagProps = {
    editVisibility,
    toggleEditVisibility,
    loading,
    name,
    setName,
    tagType,
    editTagging,
  };

  return (
    <>
      <div
        className={"d-flex w-100percent row no-gutters justify-content-end "}
      >
        <div className="col-md-6 d-flex justify-content-end">
          <CreateTag props={createTagProps} />
        </div>
      </div>

      <EditTag props={editTagProps} />
      <Spin tip="Loading...." size="small" spinning={loadingRows}>
        <div className="example-wrapper h-minus-180">
          <div className="ag-theme-alpine  w-100percent h-100percent">
            <AgGridReact
              rowData={taggingData}
              columnDefs={columnDefs}
              defaultColDef={gridOption}
              enableCellTextSelection={true}
              animateRows={true}
              frameworkComponents={frameworkComponents}
            ></AgGridReact>
          </div>
        </div>
      </Spin>
    </>
  );
}
